import { useBackgroundVisitUploadStore } from "@/store/backgroundVisitUpload.store";
import { BackgroundVisitUploadItem } from "./BackgroundVisitUploadItem";
import { CloudOff } from "lucide-react";
import { t } from "i18next";

export const BackgroundVisitUploadPanel = (): JSX.Element => {
  const { uploads, cancelVisitToUpload, startVisitToUpload } =
    useBackgroundVisitUploadStore();

  return (
    <div className="divide-y">
      {uploads.length === 0 ? (
        <div className="flex items-center justify-center gap-2">
          <CloudOff className="text-primary" />
          <span className="text-sm">
            {t("backgroundVisitUpload.emptyFiles")}
          </span>
        </div>
      ) : (
        uploads.map((backgroundVisit, index) => (
          <BackgroundVisitUploadItem
            key={index}
            backgroundVisitUpload={backgroundVisit}
            onCancel={() => {
              cancelVisitToUpload(backgroundVisit.id);
            }}
            onStart={() => {
              void startVisitToUpload(backgroundVisit.id);
            }}
          />
        ))
      )}
    </div>
  );
};
